import { render, staticRenderFns } from "./ResultIndexLevelIntrovert.vue?vue&type=template&id=b2d81238&scoped=true&"
import script from "./ResultIndexLevelIntrovert.vue?vue&type=script&lang=js&"
export * from "./ResultIndexLevelIntrovert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d81238",
  null
  
)

export default component.exports